"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HintDateRange = function HintDateRange(_ref) {
  var coordinate = _ref.coordinate,
      zone = _ref.zone;
  var format = 'LL/dd/yyyy';

  var formattedStartDate = _luxon.DateTime.fromMillis(coordinate.x0, {
    zone: zone
  }).toFormat(format);

  var formattedEndDate = _luxon.DateTime.fromMillis(coordinate.x, {
    zone: zone
  }).toFormat(format);

  return /*#__PURE__*/_react["default"].createElement("div", null, "".concat(formattedStartDate, " - ").concat(formattedEndDate));
};

HintDateRange.propTypes = {
  coordinate: _propTypes["default"].shape({
    x0: _propTypes["default"].number.isRequired,
    x: _propTypes["default"].number.isRequired
  }).isRequired,
  zone: _propTypes["default"].string
};
HintDateRange.defaultProps = {
  zone: 'local'
};
var _default = HintDateRange;
exports["default"] = _default;